export default {
  "placeholder.input": "Nhập vào đây...",
  "placeholder.select": "Chọn một tùy chọn",
  "placeholder.search": "Tìm kiếm tại đây...",
  "placeholder.selectDate": "Chọn ngày",
  "placeholder.selectTime": "Chọn thời gian",
  "placeholder.enterText": "Vui lòng nhập văn bản",
  "placeholder.uploadFile": "Nhấn hoặc kéo tệp vào đây để tải lên",
  "placeholder.noData": "Không có dữ liệu",
  "placeholder.loading": "Đang tải, vui lòng chờ...",
  "placeholder.error": "Đã xảy ra lỗi, vui lòng thử lại",
  "placeholder.noResults": "Không tìm thấy kết quả",
  "placeholder.selectMultiple": "Chọn nhiều tùy chọn",
  "placeholder.enterValue": "Nhập giá trị",
  "placeholder.chooseFile": "Chọn tệp",
  "placeholder.enterEmail": "Nhập địa chỉ email của bạn",
  "placeholder.enterPassword": "Nhập mật khẩu của bạn",
  "placeholder.confirmPassword": "Xác nhận mật khẩu của bạn",
  "placeholder.enterUsername": "Nhập tên người dùng của bạn",
  "placeholder.enterPhoneNumber": "Nhập số điện thoại của bạn",
  "placeholder.enterAddress": "Nhập địa chỉ của bạn",
  "placeholder.enterCity": "Nhập thành phố của bạn",
  "placeholder.enterState": "Nhập tỉnh/thành phố của bạn",
  "placeholder.enterZipCode": "Nhập mã bưu điện của bạn",
  "placeholder.enterCountry": "Nhập quốc gia của bạn",
  "placeholder.enterDescription": "Nhập mô tả",
  "placeholder.enterSearchTerm": "Nhập từ khóa tìm kiếm",
  "placeholder.selectCategory": "Chọn danh mục",
  "placeholder.selectOption": "Chọn một tùy chọn",
  "placeholder.enterTitle": "Nhập tiêu đề",
  "placeholder.enterName": "Nhập tên của bạn",
  "placeholder.enterComment": "Nhập bình luận của bạn",
  "placeholder.enterFeedback": "Nhập phản hồi của bạn",
  "placeholder.enterNotes": "Nhập ghi chú",
  "placeholder.enterDetails": "Nhập chi tiết",
  "placeholder.enterMessage": "Nhập tin nhắn của bạn",
  "placeholder.enterQuery": "Nhập truy vấn của bạn",
  "placeholder.enterSearchQuery": "Nhập truy vấn tìm kiếm",
  "placeholder.enterInput": "Nhập dữ liệu",
  "placeholder.enterTextHere": "Nhập văn bản tại đây",
  "placeholder.enterSearchText": "Nhập văn bản tìm kiếm",
  "placeholder.enterSearchKeyword": "Nhập từ khóa tìm kiếm",
  "placeholder.enterSearchPhrase": "Nhập cụm từ tìm kiếm",
  "placeholder.enterSearchValue": "Nhập giá trị tìm kiếm",
  "placeholder.enterSearchInput": "Nhập dữ liệu tìm kiếm",
  "placeholder.enterSearchField": "Nhập trường tìm kiếm",
  "placeholder.enterSearchCriteria": "Nhập tiêu chí tìm kiếm",
  "placeholder.enterSearchTermHere": "Nhập từ khóa tìm kiếm tại đây",
  "placeholder.enterSearchQueryHere": "Nhập truy vấn tìm kiếm tại đây",
  "placeholder.enterSearchKeywordHere": "Nhập từ khóa tìm kiếm tại đây",
  "placeholder.enterSearchPhraseHere": "Nhập cụm từ tìm kiếm tại đây",
  "placeholder.enterSearchValueHere": "Nhập giá trị tìm kiếm tại đây",
  "placeholder.enterSearchInputHere": "Nhập dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchFieldHere": "Nhập trường tìm kiếm tại đây",
  "placeholder.enterSearchCriteriaHere": "Nhập tiêu chí tìm kiếm tại đây",
  "placeholder.enterSearchTextHere": "Nhập văn bản tìm kiếm tại đây",
  "placeholder.enterSearchInputValue": "Nhập giá trị dữ liệu tìm kiếm",
  "placeholder.enterSearchInputText": "Nhập văn bản dữ liệu tìm kiếm",
  "placeholder.enterSearchInputKeyword": "Nhập từ khóa dữ liệu tìm kiếm",
  "placeholder.enterSearchInputPhrase": "Nhập cụm từ dữ liệu tìm kiếm",
  "placeholder.enterSearchInputCriteria": "Nhập tiêu chí dữ liệu tìm kiếm",
  "placeholder.enterSearchInputField": "Nhập trường dữ liệu tìm kiếm",
  "placeholder.enterSearchInputTerm": "Nhập từ khóa dữ liệu tìm kiếm",
  "placeholder.enterSearchInputQuery": "Nhập truy vấn dữ liệu tìm kiếm",
  "placeholder.enterSearchInputValueHere":
    "Nhập giá trị dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchInputTextHere":
    "Nhập văn bản dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchInputKeywordHere":
    "Nhập từ khóa dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchInputPhraseHere":
    "Nhập cụm từ dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchInputCriteriaHere":
    "Nhập tiêu chí dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchInputFieldHere":
    "Nhập trường dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchInputTermHere":
    "Nhập từ khóa dữ liệu tìm kiếm tại đây",
  "placeholder.enterSearchInputQueryHere":
    "Nhập truy vấn dữ liệu tìm kiếm tại đây",
};
